import i18n from 'i18next';

// json resources
import enResource from '../locales/en-US/index';
import zhResource from '../locales/zh-Hant/index';
import deResource from '../locales/de-DE/index';
import esResource from '../locales/es-ES/index';
import frResource from '../locales/fr-FR/index';
import hiResource from '../locales/hi-IN/index';
import jaResource from '../locales/ja-JP/index';
import itResource from '../locales/it-IT/index';
import { LanguageDetector } from './langDetector';

// translations https://www.iana.org/assignments/language-tags/language-tags.xml
// zh-Hant => Chinese,in simplified script
const resources = {
  de: deResource,
  en: enResource,
  es: esResource,
  fr: frResource,
  hi: hiResource,
  it: itResource,
  ja: jaResource,
  zh: zhResource,
};

const languageDetector = new LanguageDetector();
const selectedLanguage: any = languageDetector.detect();

// for all options read: https://www.i18next.com/overview/configuration-options + https://react.i18next.com/latest/i18next-instance
const options = {
  resources, // Can be loaded in runtime with i18n.addResourceBundle or fetched asynchronously based on selected language
  lng: selectedLanguage, // language intializes with
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  saveMissing: false, // If a translation is missing try to save it with a value?
  returnEmptyString: false, // allows empty string as valid translation
  react: {
    bindI18n: 'languageChanged',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'u', 'span', 'p'],
    useSuspense: false,
  },
  compatibilityJSON: 'v3',
};

// We need to create a separate instance of i18n, as it conflicts with the one used in the junglescout_client
const i18nInstance = i18n.createInstance();

i18nInstance.init(options);

const t = i18nInstance.t.bind(i18nInstance);
export { t };

export default i18nInstance;
